// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from "vuex";
import Element from "element-ui";
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en'
import axios from 'axios'
import $ from 'jquery'
import '@/style/index.css'
import dataV from '@jiaminghi/data-view'
import elTableInfiniteScroll from 'el-table-infinite-scroll';

// axios.defaults.withCredentials = true // 跨域保存session有用
// axios.defaults.baseURL = 'http://localhost:8000' // 打包的时候直接删掉，默认基础路径在这里配置

Vue.use(Element, {locale})
Vue.use(Vuex)
Vue.use(dataV)
Vue.use(elTableInfiniteScroll);
Vue.prototype.$axios = axios
Vue.config.productionTip = false


const moduleUser = {  //login
  state: {
    bes_server: "https://server.globalbes.sg/bes_server/dbapi?cmd=",  //生产服
    cms_server: "https://server.globalbes.sg/cms_dashb/dbapi?cmd=",  //生产服
    cmsdb_server: "https://server.globalbes.sg/dbcms/dbapi?cmd=",  //生产服
    dev_server: "https://server.globalbes.sg/cmsdev/dbapi?cmd=",  //生产服
    hcs_server: "https://server.globalbes.sg/hcs_server/dbapi?cmd=",
    cmsqa_server: "https://server.globalbes.sg/cms_qa/dbapi?cmd=",
    cmsbim_server: "https://server.globalbes.sg/cms_bim/dbapi?cmd=",
    server241_address: "https://server.globalbes.sg/",
    // vr_address: "http://vr.cmstech.sg/",
    vr_address: "http://hik.globalbes.sg/vradmin/?m=login",
    bim_server_ip: "https://bim.globalbes.sg",
    bim_app_key: "WXV779X1ORqkxbQZZOyuoFW58UyZZOmrX6UT",
    bim_app_secret: "5850b40146687cc795d992e94dc04d1ba7d76ce40dd67a59a79f9066c375df2f",
    header_content: "Welcome to the BES Smart Dashboard",
    header_title: "BES Smart Dashboard",
    user: {
      c_company_id: ""
    }
  },
  getters: {
    getUserCompanyId(state) {
      return state.user.c_company_id
    },
    getBesServer(state) {
      return state.bes_server
    },
    getCmsServer(state) {
      return state.cms_server
    },
    getCmsQaServer(state) {
      return state.cmsqa_server
    },
    getCmsBimServer(state) {
      return state.cmsbim_server
    },
    getServer241Address(state) {
      return state.server241_address
    },
    getBimServerIp(state) {
      return state.bim_server_ip
    },
    getBimAppKey(state) {
      return state.bim_app_key
    },
    getBimAppSecret(state) {
      return state.bim_app_secret
    },
    getDevServer(state) {
      return state.dev_server
    },
    getHCSServer(state) {
      return state.hcs_server
    },
    getCmsDBServer(state) {
      return state.cmsdb_server
    },
    getVrAddress(state) {
      return state.vr_address
    },
    getHeaderContent(state) {
      return state.header_content
    },
    getHeaderTitle(state) {
      return state.header_title
    }
  },
  mutations: {
    setCompanyId(state, c_company_id) {
      state.user.c_company_id = c_company_id
    }
  },
  actions: {
    saveCompanyId(context, c_company_id) {
      context.commit('setCompanyId', c_company_id)
    }
  }
}

const moduleColor = {
  state: {
    count: 0,
    dashboard_color: ['#325B69', '#698570', '#AE5548', '#6D9EA8', '#9CC2B0', '#C98769'],
    chart_color: ['#F68F62', '#628D53', '#A568CB', '#C55EB2', '#7BF1FA', '#F1D15D', '#325B69', '#FF84B0',
      '#698570', '#AE5548', '#6D9EA8', '#9CC2B0', '#C98769', '#52B3Bd', '#7DD1AA', , '#4D7782',
      '#F78763', '#E4F102', '#325B69', '#C4C1C2'],
  }
}

const store = new Vuex.Store({
  modules: {
    user: moduleUser,
    color: moduleColor
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>',
  data: {
    charts: []
  }
})



// WEBPACK FOOTER //
// ./src/main.js